<div class="row">
  <div class="col-12 pt-3">
    <div class="row">
      <div class="col-10 p-0" *ngIf="isDataLoaded">
        <app-wizard-head [wizardInput]="wizardInput"></app-wizard-head>
      </div>
    </div>
  </div> 
  <div class="col-12 contentPortion p-0" *ngIf="isDataLoaded">
      <!-- <mat-vertical-stepper [linear]="isLinear" #stepper>
        <mat-step label="Analyze petition" >
            <ng-template matStepLabel>Analyze petition</ng-template>
            <p>DDDDDDDDd4444444444444</p>
        </mat-step>
        <mat-step label="Generate Draft Petition for review">
          <ng-template matStepLabel>Generate Draft Petition for review</ng-template>
          <review-petition-library [primaryData]="inputData" [isWizard]="true" style="width:100%"></review-petition-library>
        </mat-step>
        <mat-step label="Print Petition">
          <print-petition-library [primaryData]="inputData" [isWizard]="true" style="width:100%"></print-petition-library>
        </mat-step>
      </mat-vertical-stepper> -->

      <!-- <review-petition-library [primaryData]="inputData" [isWizard]="true" style="width:100%"></review-petition-library> -->
      <print-petition-library [primaryData]="inputData" [isWizard]="true" style="width:100%"></print-petition-library>
  </div>
</div>